<template>
  <v-row class="h-100p pa-4">
    <SimpleWarningDialog
      v-if="successApproveDialog"
      icon="mdi-checkbox-marked-circle-outline"
      :text="warningDialogText"
      :secondaryBtn="secondaryBtn"
      @onPrimary="warningDialogAction"
      @onSecondary="onDialogCanceled"
    />
    <v-col>
      <div class="pdf-wrapper d-flex flex-column align-center">
        <div
          v-if="isLoading"
          class="d-flex flex-column align-center"
          style="width: 100%"
        >
          <v-skeleton-loader style="width: 70%" type="article@4">
          </v-skeleton-loader>
        </div>

        <object id="pdf_viewer" :data="content" type="application/pdf" />
      </div>
    </v-col>
    <div class="buttons-wrapper">
      <v-progress-circular
        v-if="loading"
        size="32"
        indeterminate
        color="primary"
      ></v-progress-circular>
      <v-btn
        v-if="
          !(
            (taskApprovalResult != null && taskApprovalResult != 'retry') || 
            (taskEnablePreApprovementResult == 'true'  &&  taskRequirePreApprovementResult == 'true' && taskPreApprovalResult == 'false')  || 
            taskSendToApprovalResult == 'false'
          )
        "
        class="ma-1 ml-3"
        large
        color="black"
        @click="onClickReject"
        :disabled="disabled"
      >
        <span class="color--primary--white">{{ rejectText }}</span>
      </v-btn>
      <v-btn
        class="ma-1"
        large
        color="primary"
        ma-1
        @click="onClickApprove"
        :disabled="disabled"
      >
        <span class="color--primary--white">{{
          (taskApprovalResult != null && taskApprovalResult != "retry") ||
          (taskEnablePreApprovementResult == "true"  &&  taskRequirePreApprovementResult == "true" && taskPreApprovalResult == 'false')  || 
          taskSendToApprovalResult == "false"
            ? $t("finalizeProcess")
            : approveText
        }}</span>
      </v-btn>
    </div>
  </v-row>
</template>

<script>
import ShowApproval from "./mixin/ShowApproval";

export default {
  mixins: [ShowApproval]
};
</script>

<style lang="scss" scoped>
$primaryColor: #0032a0;
#pdf_viewer {
  width: 70%;
  height: 800px;
}
.title {
  color: $primaryColor;
}
.header-table-divider {
  margin-top: 2%;
}
.btn-new-identity {
  background-color: $primaryColor !important;
  color: white;
}
.v-btn {
  text-transform: none;
}
.button-container {
  align-items: center;
  justify-content: center;
  display: flex;
}
.pdf-wrapper {
  margin-bottom: 150px;
  .document-pdf {
    width: 550px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/approval/ShowApproval.vue